// Reads the B2C phone-number claim used to tie a signed-in guest to their
// DGB account. Guarded with optional chaining because MSAL's active account
// can still be null momentarily on first render (before redirect handling
// settles) even for an otherwise-authenticated guest - this must never throw.
export const getDgbPhoneClaim = (activeAccount) =>
  activeAccount?.idTokenClaims?.["signInNames.phoneNumber"];

// Builds the link to the external appointment scheduler (scheduler.cbac.com).
//
// Confirmed directly against CBA-Scheduler-Frontend's own source: it only
// ever reads three query params. Everything else (year/make/model/mileage/
// vin/firstName/lastName/email) is silently ignored - the scheduler always
// has the guest pick their vehicle manually via its own year/make/model
// dropdowns, or select it from their authenticated DGB garage.
//
// - careplus=true switches on Care+-specific copy on the no-location screen.
// - vehicleId only does anything once the guest is authenticated there too -
//   it's matched against that authenticated session's own DGB garage, so
//   it's only useful for a vehicle that already has a DGB record.
// - dgb=<phone> is used as the loginHint for an immediate, forced
//   loginRedirect if the guest isn't already authenticated on the scheduler.
//   Not SSO, but streamlines re-authentication when a session isn't already
//   shared/warm.
export const buildSchedulerUrl = ({ vehicleGuid, phone } = {}) => {
  const params = new URLSearchParams({ careplus: "true" });

  if (vehicleGuid) params.set("vehicleId", vehicleGuid);
  if (phone) params.set("dgb", phone);

  return `${process.env.REACT_APP_SCHEDULER_URL}/?${params.toString()}`;
};
